import { render, staticRenderFns } from "./CreateGrayscaleFormExternal.vue?vue&type=template&id=412ec2c4&scoped=true&"
import script from "./CreateGrayscaleFormExternal.vue?vue&type=script&lang=ts&"
export * from "./CreateGrayscaleFormExternal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGrayscaleFormExternal.vue?vue&type=style&index=0&id=412ec2c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ec2c4",
  null
  
)

export default component.exports